export default "__VITE_ASSET__D9$8F98U__"